<template>
  <div>
    <video ref="videoPlayer1" controls :src="videoUrl1" autoplay muted loop style="width: 100%;"></video>
  </div>
  <div class="cel-stage" style="max-width: 100vw">
    <CelebrationAnimation />
    <div style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); background-color: rgba(255, 255, 255, 0.8); padding: 20px;">
      <h1>Welcome to our celebration!</h1>
      <p>Enjoy the festivities!</p>
    </div>
  </div>
  <div>
    <video ref="videoPlayer2" controls :src="videoUrl2" autoplay muted loop style="width: 100%;"></video>
  </div>
</template>

<script>
import CelebrationAnimation from '../components/CelebrationAnimation.vue'

export default {
  name: 'App',
  data(){
    return{
      videoUrl1: require('@/assets/videos/greeting_cakes.mp4'),
      videoUrl2: require('@/assets/videos/greeting_general.mp4')
    };
  },
  components: {
    CelebrationAnimation
  }
};
</script>

<style scoped>
/* Scoped to this page.

   This block was unscoped and targeted #app, but #app is the Vue application
   root -- rendered by main.js, not by this component. Every page therefore
   inherited font-family: Avenir, text-align: center, color and margin-top: 60px,
   which is why plan cards on /WishboardCreate rendered centre-aligned even
   though nothing there asked for it.

   The template also contained a second element with id="app", so the duplicate
   id matched as well. Both are fixed here: the style is scoped, and the page uses
   its own class.
*/
.cel-stage {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

/* CSS styles to hide default browser controls */
video::-webkit-media-controls {
  display: none !important;
}

video::-webkit-media-controls-start-playback-button {
  display: none !important;
}

video::-webkit-media-controls-enclosure {
  overflow: hidden !important;
}

video::-webkit-media-controls-panel {
  width: calc(100% + 30px) !important;
}
</style>
